module.exports = __webpack_public_path__ + "media/images/lb/100-8ee39ff901f92e6e52bb834ec1fd34be.svg";